import { render, staticRenderFns } from "./AdminModal.vue?vue&type=template&id=561fbeb0&scoped=true"
import script from "./AdminModal.vue?vue&type=script&lang=js"
export * from "./AdminModal.vue?vue&type=script&lang=js"
import style0 from "./AdminModal.vue?vue&type=style&index=0&id=561fbeb0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561fbeb0",
  null
  
)

export default component.exports